import { IContext } from "@src/context";
import { vhmannouncement } from "@src/proto/jsonapi";

import "./index.css";
import { jsonFetch } from "@src/utils/fetch";

const ANNOUNCEMENTS_CONFIG = "/api/announcements.json";

interface IAnnouncement {
  title?: string;
  url?: string;
}

export function setupAnnouncement(context: IContext) {
  const { locale } = context;

  // fetch announcements
  jsonFetch<vhmannouncement.IAnnouncements>(ANNOUNCEMENTS_CONFIG).then(
    (res = {}) => {
      const announcements =
        (res.announcements &&
          (res.announcements[locale] as unknown as IAnnouncement[])) ||
        [];

      if (announcements.length > 0) {
        showAnnouncement(announcements);
      }
    }
  );
}

function showAnnouncement(announcements: IAnnouncement[]) {
  // add wrap in header to fixed https://theplanttokyo.atlassian.net/browse/VHM-681
  const announcementWrap = document.createElement("div");
  announcementWrap.classList.add("container-header-block");
  announcementWrap.style.backgroundColor = "#f8b62d";
  // create announcement element
  announcementWrap.innerHTML = `<div class="element-announcement">
    <div class="container-wrapper">
      ${announcements
        .map((announcement) => {
          return `
          <p>${
            announcement.url
              ? `<a href="${announcement.url}">${announcement.title}</a>`
              : announcement.title
          }</p>
          `;
        })
        .join("")}
    </div>
  </div>
  `;

  // prepend announcement to header
  document.querySelector(".container-header")?.prepend(announcementWrap);

  // increase header height
  const announcementHeight = announcementWrap.offsetHeight;
  const root = document.documentElement as HTMLElement;
  root.style.setProperty(
    "--header-height",
    `${
      parseFloat(getComputedStyle(root).getPropertyValue("--header-height")) +
      announcementHeight
    }px`
  );
  root.style.setProperty(
    "--header-height-view-lg",
    `${
      parseFloat(
        getComputedStyle(root).getPropertyValue("--header-height-view-lg")
      ) + announcementHeight
    }px`
  );
}
